import React, { useEffect, useState, useContext, useRef } from "react";
import GraphicalReport from "../GraphicalReport/GraphicalReport";
import { icon_pencil, iconInforme } from "../../helpers/ImagesCache";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";
import { useAnalytics } from "../../hooks/useAnalytics";

const DialogFinish = ({
  selectedReport,
  onSaveReport,
  callbackCancel,
  onUpdateContext,
}) => {
  const T = useTranslation();
  const { trackReportGenerated, trackReportSaved } = useAnalytics();

  const inputTextRef = useRef();

  const handlerClose = () => {
    handleGuardarInforme();
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handleGuardarInforme = () => {
    if (onSaveReport) {
      // Analytics
      const reportName = inputTextRef?.current?.value || `Caso_${Date.now()}`;
      trackReportGenerated('24h', {
        simulation_type: selectedReport.type || 'unknown',
        report_name: reportName,
        includes_quality: selectedReport.calidadRcp?.length > 0,
        includes_skills: selectedReport.nonTechnical?.some(skill => skill.selectedOption !== null),
        total_interventions: selectedReport.history?.length || 0,
        duration: selectedReport.stopCase && selectedReport.startCase ? 
          (selectedReport.stopCase - selectedReport.startCase) / 1000 : 0
      });
      
      trackReportSaved(reportName, {
        simulation_type: selectedReport.type || 'unknown',
        save_method: '24h',
        file_size: 'estimated'
      });
      
      onSaveReport();
      window.location.href = "/reports";
    }
  };

  const handlerChangeText = () => {
    if (onUpdateContext) {
      onUpdateContext("name", inputTextRef.current.value);
    }
  };

  return (
    <>
      <FloatingDialog isOpen={true} variant={"bottom"}>
        <div>
          <div className="z-[0] px-4 flex flex-col w-full items-center justify-start gap-5">
            <div className="flex w-full items-center justify-between gap-4 font-[600] text-[#0007] mx-10">
              <div className="flex items-center gap-4">
                <img src={iconInforme} alt={iconInforme} />
                <span className="uppercase">{T("Informe del caso")}</span>
              </div>
              <SimpleButton disabled={!inputTextRef?.current?.value} onClick={handlerClose} text={T("saveReport")}/>
            </div>
          </div>
          <div className="w-full border-b-2 border-b-solid border-b-gay-500 pb-5 pt-5">
            <div className="text-xl font-[500] flex gap-4">
              <input
                ref={inputTextRef}
                type="text"
                name=""
                id=""
                className="w-10/12 p-1"
                onChange={handlerChangeText}
                placeholder={T("Ingrese el nombre para el informe")}
              />
              <img src={icon_pencil}></img>
            </div>
          </div>
          <div className="overflow-y-auto">
            {
              <GraphicalReport
                hideName={true}
                selectedReport={{
                  timeline: selectedReport,
                }}
                historyReport={true}
                header={true}
                minimized={false}
              />
            }
            <div
              id="report-pdf"
              className="hidden p-[10px]"
              style={{
                width: "auto",
                minWidth: "auto",
                maxWidth: "none",
                margin: "0 auto",
                backgroundColor: "#ffffff",
              }}
            >
              {
                <GraphicalReport
                  isNameEditable={false}
                  selectedReport={{
                    timeline: selectedReport,
                  }}
                  historyReport={true}
                  minimized={false}
                  header={true}
                  Add
                  commentMore
                  actions
                />
              }
            </div>
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogFinish;
